import ResourcesAPI from '../../api/ResourcesAPI';
import * as types from './AuthActionTypes';
import * as CompanyFeatures from '../../services/CompanyFeatures';
import { dataRetrievalFailure, updateLoadingState } from '../resource/ResourcesActions';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';

export function getCompanyFeatures(apiToken, company, multiAccountCompanies) {
  return async (dispatch) => {
    const requestsInfo = CompanyFeatures.getCompanyFeaturesRequests(apiToken, company, multiAccountCompanies);
    const promises = requestsInfo.map(({ apiToken, path }) => {
      try {
        return ResourcesAPI.getAllResources(apiToken, path);
      } catch (e) {
        dispatch(dataRetrievalFailure(e));
      }
    });
    const results = await Promise.allSettled(promises);
    const fulfilledPromises = results.filter(promiseResult => promiseResult.status === 'fulfilled');
    const featuresValues = fulfilledPromises.reduce((accumulator, currentValue) => {
      const featureData = get(currentValue, 'value.data');
      return accumulator.concat(featureData);
    }, []);
    return featuresValues;
  };
}

export function loginAdmin(admin) {
  updateLoadingState(types.LOGIN_REQUESTED);

  return dispatch => ResourcesAPI.loginAdmin(admin)
    .then(
      async (adminResponse) => {
        const company = get(adminResponse, 'data.company');
        const apiToken = get(adminResponse, 'token');
        const multiAccountCompanies = get(adminResponse, 'data.administeredCompanies', []);
        const featuresValues = await dispatch(getCompanyFeatures(apiToken, company, multiAccountCompanies));

        const adminResponseClone = cloneDeep(adminResponse);
        adminResponseClone.data.features = CompanyFeatures.getFeaturesByCompanyMap(featuresValues);
        return dispatch(loginAdminSuccess(adminResponseClone));
      },
      error => dispatch(loginAdminFailure(error)),
    );
}

export function loginAdminSuccess(admin) {
  const loggedInAdmin = admin.data;
  loggedInAdmin.token = admin.token;
  return {
    type: types.LOGIN_SUCCESS, loggedInAdmin,
  };
}

export function loginAdminFailure(error) {
  return {
    type: types.LOGIN_FAILURE, error,
  };
}

export function signoutUser() {
  return {
    type: types.SIGNOUT_USER,
  };
}

export function setAdmin(admin) {
  return {
    type: types.SET_ADMIN,
    admin,
  };
}

export function switchAdmin(oldAdmin, selectedOption) {
  const selectedCompanyId = selectedOption.value;
  // find by compayIdß
  const selectedAdmin = oldAdmin.administeredCompanies.find(adminComp => adminComp.company.id === selectedCompanyId);
  const newAdministeredCompanies = oldAdmin.administeredCompanies.filter(adminComp => adminComp.company.id !== selectedCompanyId);
  const currentAdmin = {
    id: oldAdmin.id,
    company: oldAdmin.company,
    apiToken: oldAdmin.token,
  };
  newAdministeredCompanies.push(currentAdmin);
  const admin = {
    ...oldAdmin,
    id: selectedAdmin.id,
    token: selectedAdmin.apiToken,
    company: selectedAdmin.company,
    administeredCompanies: newAdministeredCompanies,
  };
  return {
    type: types.SWITCH_ADMIN,
    admin,
  };
}
